import axios from 'axios';

import {getCookie} from "../utils/cookie";
import {alert} from "../utils/alertify";
import {
    generateKeyLocalStorage,
    PREFIX_CACHE,
    storageGetDataByKey,
    storageRemoveDataByKey, storageSetDataByKey
} from "../utils/localStorage";

export function makeRequest(options, returnStatus, cacheName, returnError) {

    /**
     * Токен
     */
    const auth = getCookie('aupd_token');

    if (cacheName) {
        /**
         * Ключ кэша и проверка наличия данных
         */
        const dataInCache = storageGetDataByKey(generateKeyLocalStorage(cacheName, auth));

        /**
         * Удаление похожих записей, если точного кэша нет
         */
        if (!dataInCache) {
            let prefixRegex;

            /**
             * Проверяем: есть ли параметр вида -[123]
             */
            if (/\-\[\d+\]/.test(cacheName)) {
                const baseName = cacheName.split('-[')[0];
                prefixRegex = new RegExp(`^${PREFIX_CACHE}${baseName}-\\[\\d+\\]-`);
            } else {
                prefixRegex = new RegExp(`^${PREFIX_CACHE}${cacheName}`);
            }
            storageRemoveDataByKey(prefixRegex);
        }

        /**
         * Вернуть данные из кэша, если есть
         */
        if (cacheName && dataInCache) {
            return Promise.resolve({ data: dataInCache })
        }
    }

    return axios(options)
        .then(response => {
            /**
             * Записываем в кэш данные
             */
            if (cacheName) {
                storageSetDataByKey(generateKeyLocalStorage(cacheName, auth), response.data)
            }

            if (response.status < 200 && response.status > 300 && response.status !== 404) throw response;
            if (options.url.includes('/v1/sudir/main')) {
                return response?.data
            }

            if (options.url.includes('/v3/auth/rights/')) {
                return response?.data
            }
            if (response?.data?.error) throw response;
            if (options.url === '/v2/redirect') {
                return response?.request?.responseURL
            }
            if (returnStatus) {
                return {
                    data: response.data,
                    status: response.status
                }
            }

            return response.data;
        })
        .catch(error => {
            if (options.url === '/v2/external-partners/generate-token' || options.url.includes('/v2/external-partners/account-linking/')) {
                throw error?.response
                return
            }

            if (returnError) {
                //console.log(error?.response.status)
                //throw error?.response?.data;
                return {
                    error: error?.response
                };
            }

            if (error?.response?.data) {
                throw error?.response?.data;
                return;
            }
            if( error.response ){
                alert({mode: 'error', message: error?.response?.data?.[0]?.errorMessage || error?.response?.data?.error || 'Произошла ошибка'})
            }
            throw error
        });
}


export function request({ method, url, data, params, token, headers }, returnStatus = false, cacheName = null, returnError = false) {
    const options = { method, url };

    options.headers = {
        Authorization: `Bearer ${getCookie('aupd_token')}`,
        ...headers
    };

    if (data) options.data = data;

    if (params) options.params = params;

    options.withCredentials = true;

    return makeRequest(options, returnStatus, cacheName, returnError);
}
